import { render, staticRenderFns } from "./MonitoringQuerySummary.vue?vue&type=template&id=37ca7c4b&"
import script from "./MonitoringQuerySummary.vue?vue&type=script&lang=ts&"
export * from "./MonitoringQuerySummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports